export default __webpack_public_path__ + "static/faherty_logo-dbaec33a20c2843c2b0c952983b536d5.png";